export const expression = {
  error: {
    DIVISION_BY_ZERO:
      "Une erreur de calcul s'est produite.<br />La division par zéro n'est pas possible.",
    NEGATIVE_SQRT_ROOT:
      "Une erreur de calcul s'est produite.<br />La racine carrée d'un nombre négatif n'est pas possible.",
    INVALID_RESULT:
      "Une erreur est survenue lors de l'évaluation du calcul.<br />Veuillez vérifier les valeurs que vous avez saisies pour le calcul.",
    MISSING_VALUES:
      "Un champ manquant empêche de calculer correctement la formule mathématique. Veuillez contacter le <HelpLink>Centre d'aide STELAR</HelpLink> pour obtenir de l'aide.",
    NON_NUMERIC_VALUES:
      "Un champ non numérique empêche de calculer correctement la formule mathématique. Veuillez contacter le <HelpLink>Centre d'aide STELAR</HelpLink> pour obtenir de l'aide.",
    UNEXPECTED_ERROR:
      "Il y a une erreur dans la formule mathématique. Veuillez contacter le <HelpLink>Centre d'aide STELAR</HelpLink> pour obtenir de l'aide.",
  },
};
